import {ApplicationRef, ChangeDetectorRef, Component, Input, OnInit} from '@angular/core';
import {ModalController} from "@ionic/angular";
import {PromotionService} from "../../services/promotion.service";

@Component({
  selector: 'app-fortune-wheel',
  templateUrl: './fortune-wheel.component.html',
  styleUrls: ['./fortune-wheel.component.scss'],
})
export class FortuneWheelComponent implements OnInit {
  @Input()activityUid!: string;
  rotateClass: string = '';
  rotateKnob: string = '';

  promotionCode = '';

  prizeWon?: { background: string, color: string, title: string, subtitle: string, text1: string, text2: string };
  showPrize: string = '';
  cloudText: string = 'Zakręć i zdobądź bonus!';
  prizeTemplates: { [key:string] : { background: string, color: string, title: string, subtitle: string, text1: string, text2: string }} = {
    "premia_x2": { background: '#e40e75', color: 'white', title: 'Każda premia', subtitle: 'x2', text1: 'Dotyczy każdej premii za premiowaną transakcję.', text2: 'Bonus działa dziś i przez następne dwie doby.'},
    "premia_x5pln": { background: '#e40e75', color: 'white', title: 'Każda premia', subtitle: '+5pln', text1: 'Dotyczy każdej premii za premiowaną transakcję.', text2: 'Bonus działa dziś i przez następne dwie doby.'},
    "premia_1pln": { background: '#8047ff', color: 'white', title: 'Zdobywasz', subtitle: '1pln', text1: '', text2: ''},
    "premia_2pln": { background: '#8047ff', color: 'white', title: 'Zdobywasz', subtitle: '2pln', text1: '', text2: ''},
    "premia_5pln": { background: '#8047ff', color: 'white', title: 'Zdobywasz', subtitle: '5pln', text1: '', text2: ''},
  };
  constructor(
    private modal: ModalController,
    private promotionService: PromotionService) {

  }

  ngOnInit() {
    console.warn(`showing activity fortune for: ${this.activityUid}`);
    this.promotionService.getPromotion(this.activityUid)
      .then(result => {
        this.promotionCode = result.promotionCode;
        this.prizeWon = this.prizeTemplates[this.promotionCode];
        console.log(`set promotionCode: ${this.promotionCode}`);
        console.log(this.prizeWon);
      }).catch(err => console.error(err));
  }
  render: boolean = true;
  onZakrec_click() {
    this.cloudText = "Zacieraj ręce ...";
    this.rotateClass = this.promotionCode;
    // const rnd = Math.floor(Math.random() * 6) + 1;
    // if (rnd === 5) {
    //   this.rotateClass = 'anim--icon-again';
    // } else {
    //   this.rotateClass = this.promotionCode;
    // }
    this.rotateKnob = 'anim--icon-knob';
    setTimeout(() => {
      this.cloudText = 'Jeszcze chwila!';
    }, 5000);
    setTimeout(() => {
      this.cloudText = 'Już już...';
    }, 8000);
    setTimeout(() => {
      this.cloudText = 'Gratulacje!';
    }, 10000);
    setTimeout(() => {
      this.showPrize = 'active';
    }, 11000);
    setTimeout(() => {
      this.render = false;
    }, 11060);
    setTimeout(() => {
      this.render = true;
    }, 11100)
  }
  onClose_click() {
    return this.modal.dismiss(null, "finished");
  }
  onDismiss_click() {
    return this.modal.dismiss(null);
  }
}
